var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.06976 10.275L6.38393 11.7772C5.40682 10.9067 4.6781 9.84021 4.25883 8.66708L6.56201 8.14872C6.94192 9.09023 7.47616 9.73553 8.06976 10.275ZM9.51815 4.81644L4.76933 0.584961L0.0205078 4.81644H3.60587C3.62961 5.67331 3.70084 6.44555 3.83144 7.11201L6.13462 6.59366C6.05151 6.08588 5.99215 5.48289 5.98028 4.81644H9.51815ZM21.3902 4.81644L16.6414 0.584961L11.8926 4.81644H15.4423C15.3236 8.70939 13.9227 9.84131 12.4268 11.0367C11.8332 11.5022 11.2277 12.0099 10.7054 12.6764C10.3017 12.158 9.8387 11.7455 9.36381 11.3646L7.68986 12.8562C8.79396 13.7554 9.51815 14.4854 9.51815 16.453V21.7423H11.8926V16.453C11.8926 14.3161 12.7355 13.6391 14.0177 12.6129C15.656 11.3012 17.6743 9.67205 17.8167 4.81644H21.3902Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitRoute);
export default __webpack_public_path__ + "static/media/split_route.cdfece438c7e7be2c685629b1b0c2da7.svg";
export { ForwardRef as ReactComponent };